import { ChangeEvent, KeyboardEvent, useContext, useEffect, useRef } from "react";
import { ScannerContext } from "../../store/ScannerContextProvider";
import { DialogContext } from "../../store/DialogContextProvider";
import * as Styles from "./ScannerInput.styles";

interface ScannerInputProps {
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onKeyDown: (event: KeyboardEvent<HTMLInputElement>) => void;
}

const MAX_INPUT_LENGTH = 80;

export default function ScannerInput({ value, onChange, onKeyDown }: ScannerInputProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const { registerScannerRef } = useContext(ScannerContext);
  const { isDialogOpen } = useContext(DialogContext);

  useEffect(() => {
    registerScannerRef(inputRef.current);
  }, [registerScannerRef]);

  return (
    <Styles.StyledInputBase
      inputRef={inputRef}
      placeholder="Aguardando leitura..."
      type="text"
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      autoFocus={!isDialogOpen}
      inputProps={{ maxLength: MAX_INPUT_LENGTH }}
    />
  );
}
